import { initI18n, storedLocale } from "@dl/web-core-js/i18n";
import { AppRoot } from "@dl/web-core-js/shell";
import type { Brand } from "@dl/web-core-js/theme";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import { nav } from "./nav";
import { router } from "./router";
import { SalesBasisProvider } from "./sales/basis";
import "./styles.css";

const brand: Brand = {
  name: "Nexpim",
  logo: "/logo.svg",
};

async function bootstrap() {
  await initI18n({
    resources: { en: { translation: en }, fr: { translation: fr } },
    ...(storedLocale() ? { initialLocale: storedLocale()! } : {}),
  });

  const container = document.getElementById("root");
  if (!container) throw new Error("#root is missing from index.html");

  createRoot(container).render(
    <StrictMode>
      {/* Above AppRoot so every page reads the same basis. */}
      <SalesBasisProvider>
        <AppRoot brand={brand} nav={nav} basePath="/api/2.0" defaultTheme="light">
          <RouterProvider router={router} />
        </AppRoot>
      </SalesBasisProvider>
    </StrictMode>,
  );
}

void bootstrap();
